module.exports = __webpack_public_path__ + "static/media/dawexpolScreen.43539c35.jpg";